import { render } from "./Nav.vue?vue&type=template&id=1a0b63de"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=1a0b63de&lang=css"
script.render = render

export default script